<app-nav></app-nav>
<section class="healthInsuranceProposal">
  <div class="container">
    <div class="col">
      <!-- <h4 class="form-title">Proposer's Details</h4> -->
      <div class="col-12 text-center">
        <span><b>Fill correct information as it will be used<br>for policy issuance and correspondence</b></span>
      </div>
      <ul class="nav nav-pills justify-content-left main-nav-pills" role="tablist">
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'active': !proposalTab}">Proposer's Details</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'active': !insurerDetails}">Insured Details</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'active': !nomineeDetails}">Nominee Details</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'active': !healthDetails}">Good Health Declarations</a>
        </li>
      </ul>
      <div class="tab-content">
        <form name="form" #proposalFormTabOne="ngForm">
          <div [hidden]="proposalTab" class="container active"><br>
            <div class="row">
              <div class="col-2" style="padding-right:0px;">
                <p class="title mendatory">Title</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control" name="title" (change)="getGenderValue($event)"
                      [(ngModel)]="proposal.title" id="title" #title="ngModel" required>
                      <option value="M">Mr</option>
                      <option value="F">Mrs</option>
                      <option value="F">Ms</option>
                    </select>
                    <div *ngIf="title.invalid && title.touched " class="error-message">
                      <div *ngIf="title.errors.required">
                        Title is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <p class="title mendatory">First Name</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="fName" [(ngModel)]="proposal.firstName" id="fName"
                      #fName="ngModel" pattern="[a-zA-Z]+" maxlength="200" required>
                    <div *ngIf="fName.invalid && fName.touched " class="error-message">
                      <div *ngIf="fName.errors.required">
                        First Name is required.
                      </div>
                      <div *ngIf="fName.errors.pattern">
                        Please enter valid First name.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <p class="title mendatory">Last Name</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="lName" [(ngModel)]="proposal.lastName" id="lName"
                      #lName="ngModel" pattern="[a-zA-Z\s]+" maxlength="200" required>
                    <div *ngIf="lName.invalid && lName.touched " class="error-message">
                      <div *ngIf="lName.errors.required">
                        Last Name is required.
                      </div>
                      <div *ngIf="lName.errors.pattern">
                        Please enter valid Last name.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Mobile No.</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input type="text" #mobileNo="ngModel" name="mobileNo" id="mobile" class="form-control"
                      placeholder="Mobile No." [(ngModel)]="proposal.mobileNo" #mobileNo1="ngModel" maxlength="10"
                      minlength="10" (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                      inputmode="numeric" required>
                    <div *ngIf="mobileNo.invalid && mobileNo.touched " class="error-message">
                      <div *ngIf="mobileNo.errors.required">
                        Mobile number is required.
                      </div>
                      <div *ngIf="mobileNo.errors.maxlength">
                        Mobile number should not be greater than 10 digits.
                      </div>
                      <div *ngIf="mobileNo.errors.minlength">
                        Mobile number must be at least 10 digits long.
                      </div>
                      <div *ngIf="(!mobileNo.errors.minlength || mobileNo.errors.pattern) && !mobileNo.errors.required">
                        Invalid mobile number.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">E-mail Address</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="email" name="emailId" id="email" #emailId="ngModel"
                      [(ngModel)]="proposal.emailId" [email]="true" maxlength="100" required>
                    <div *ngIf="emailId.invalid && emailId.touched " class="error-message">
                      <div *ngIf="emailId.errors.required">
                        Email Address is required.
                      </div>
                      <div *ngIf="emailId.errors.email">
                        Please enter correct Email address.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">DOB</p>
                <div class="sum-insured-input reg-date-input date_input">
                  <div class="input-group form-group">
                    <div class="input-group addon">
                      <img
                        src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                      <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.dob"
                        dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:{{currentDate.getFullYear()}}"
                        placeholder="Date" name="regDate" [maxDate]="currentDate" (onBlur)="checkValue()" keepInvalid
                        [required]="true"></p-calendar>
                      <span class="input-group-addon" id="basic-addon-dueDate"></span>
                    </div>
                  </div>
                  <div *ngIf="shouldBe18" class="error-message">
                    Date of birth should be greater than 18.
                  </div>
                  <div *ngIf="DOBrequired" class="error-message">
                    Date of Birth is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Gender</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control" type="text" name="gender" #gender="ngModel"
                      [(ngModel)]="proposal.gender" required>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                    </select>
                    <!-- <input class="form-control" type="text" name="gender" #gender="ngModel"
                      [(ngModel)]="proposal.gender" pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"> -->
                    <div *ngIf="gender.invalid && gender.touched " class="error-message">
                      <div *ngIf="gender.errors.pattern">
                        Please enter valid Gender.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Address Line 1</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="addressLine1" [(ngModel)]="proposal.addressLine1"
                      id="addressLine1" #addressLine1="ngModel" maxlength="500" required>
                    <div *ngIf="addressLine1.invalid && addressLine1.touched " class="error-message">
                      <div *ngIf="addressLine1.errors.required">
                        Address is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Pin Code</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="number" name="pinCode" [(ngModel)]="proposal.pincode"
                      (keydown.space)="$event.preventDefault();" (keypress)="keyPress($event)" maxlength="6"
                      minlength="6" id="pinCode" #pinCode="ngModel"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      required>
                    <div *ngIf="invalidPincode" class="error-message">
                      Invalid pincode.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <!-- <div class="col-6">
                <button class="btn btn-bordered-blue pull-left">Save</button>
              </div> -->
              <!-- <div class="col-6 text-right">
                <button class="btn btn-bordered-blue" (click)="openModal(template)">Proceed</button>
              </div> -->
              <div class="col-12 text-center">
                <button class="btn btn-bordered-blue" [disabled]="!proposalFormTabOne.valid" (click)="nextStep('1')"
                  id="proceedPayment">Proceed</button>
              </div>
            </div>
          </div>
        </form>
        <div [hidden]="insurerDetails" class="container insuredDetails">
          <div (click)="backtoprevTab('2')" class="left-arw"></div>
          <div class="row sub-nav-tab">
            <ul class="nav nav-pills justify-content-left" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" data-toggle="pill" href="#self" data-toggle="tab">Self</a>
              </li>
              <li class="nav-item" *ngIf="quoteDetails.isspouse">
                <a class="nav-link" data-toggle="pill" href="#spouse" data-toggle="tab">Spouse</a>
              </li>
              <li class="nav-item" *ngIf="quoteDetails.childSize">
                <a class="nav-link" data-toggle="pill" href="#kid1" data-toggle="tab">1 Kid</a>
              </li>
              <li class="nav-item" *ngIf="quoteDetails.childSize === '2' || quoteDetails.childSize === '3'">
                <a class="nav-link" data-toggle="pill" href="#kid2" data-toggle="tab">2 Kid</a>
              </li>
            </ul>
            <div class="tab-content">
              <div id="self" class="container tab-pane active"><br>
                <form name="form" #selfTab="ngForm">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <input class="form-control" name="insuredMemberRelation1"
                          [(ngModel)]="proposal.insuredMemberRelation1" required>
                          <!-- <option value="Self" selected>SELF</option> -->
                        
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-2" style="padding-right:0px;">
                      <p class="title mendatory">Title</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <select class="form-control" name="selfTitle" [(ngModel)]="proposal.insuredPersonTitle1"
                            id="selfTitle" #selfTitle="ngModel" required>
                            <option value="M">Mr</option>
                            <option value="Mrs">Mrs</option>
                            <option value="MS">Ms</option>
                          </select>
                          <div *ngIf="selfTitle.invalid && selfTitle.touched " class="error-message">
                            <div *ngIf="selfTitle.errors.required">
                              Title is required.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-5">
                      <p class="title mendatory">First Name</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" type="text" name="selfFirstName"
                            [(ngModel)]="proposal.insuredPersonFirstName1" id="selfFirstName" #selfFirstName="ngModel"
                            pattern="[a-zA-Z]+" maxlength="200" required disabled>
                            <div *ngIf="selfFirstName.invalid && selfFirstName.touched " class="error-message">
                              <div *ngIf="selfFirstName.errors.required">
                                First Name is required.
                              </div>
                              <div *ngIf="selfFirstName.errors.pattern">
                                Please enter valid First name.
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-5">
                      <p class="title mendatory">Last Name</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" type="text" name="selfLastName"
                            [(ngModel)]="proposal.insuredPersonLastName1" id="selfLastName" #selfLastName="ngModel"
                            pattern="[a-zA-Z\s]+" maxlength="200" required disabled>
                            <div *ngIf="selfLastName.invalid && selfLastName.touched " class="error-message">
                              <div *ngIf="selfLastName.errors.required">
                                First Name is required.
                              </div>
                              <div *ngIf="selfLastName.errors.pattern">
                                Please enter valid Last name.
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p class="title mendatory">Date of Birth</p>
                      <div class="sum-insured-input reg-date-input">
                        <div class="input-group form-group">
                          <div class="input-group addon">
                            <img
                              src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                            <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.insuredPersonDob1"
                              dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:{{currentDate.getFullYear()}}"
                              placeholder="Date" name="regDate" [maxDate]="currentDate" (onBlur)="checkValue()"
                              (onSelect)="calculateAge()" keepInvalid required disabled></p-calendar>
                            <span class="input-group-addon" id="basic-addon-dueDate"></span>
                          </div>
                        </div>
                        <div *ngIf="shouldBe18" class="error-message">
                          Date of birth should be greater than 18.
                        </div>
                        <div *ngIf="DOBrequired" class="error-message">
                          Date of Birth is required.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4" *ngIf="membersCount == '1'">
                    <div class="col-12 text-center">
                      <button class="btn btn-bordered-blue" [disabled]="!selfTab.valid" (click)="nextStep('2')">Next</button>
                    </div>
                  </div>
                </form>
      
              </div>
              <!--if spuse this form show will optimize this code-->
              <ng-container *ngIf="quoteDetails.isspouse">
                <div id="spouse" class="container tab-pane fade"><br>
                  <form name="form" #proposalFormTabTwo2="ngForm">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <input class="form-control" name="insuredMemberRelation2"
                            [(ngModel)]="proposal.insuredMemberRelation2" required>
    
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 pr-0">
                        <p class="title mendatory">Title</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <select class="form-control" name="spouseTitle" [(ngModel)]="proposal.insuredPersonTitle2"
                              id="spouseTitle" #spouseTitle="ngModel" required>
                              <option value="M">Mr</option>
                              <option value="F">Mrs</option>
                              <option value="F">Ms</option>
                            </select>
                            <div *ngIf="spouseTitle.invalid && spouseTitle.touched " class="error-message">
                              <div *ngIf="spouseTitle.errors.required">
                                Title is required.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <p class="title mendatory">First Name</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" name="spouseFirstName"
                              [(ngModel)]="proposal.insuredPersonFirstName2" id="spouseFirstName"
                              #spouseFirstName="ngModel" pattern="[a-zA-Z]+" maxlength="200" required>
                              <div *ngIf="spouseFirstName.invalid && spouseFirstName.touched " class="error-message">
                                <div *ngIf="spouseFirstName.errors.required">
                                  First Name is required.
                                </div>
                                <div *ngIf="spouseFirstName.errors.pattern">
                                  Please enter valid First name.
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <p class="title mendatory">Last Name</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" name="spouseLastName"
                              [(ngModel)]="proposal.insuredPersonLastName2" id="spouseLastName" #spouseLastName="ngModel"
                              pattern="[a-zA-Z\s]+" maxlength="200" required>
                              <div *ngIf="spouseLastName.invalid && spouseLastName.touched " class="error-message">
                                <div *ngIf="spouseLastName.errors.required">
                                  First Name is required.
                                </div>
                                <div *ngIf="spouseLastName.errors.pattern">
                                  Please enter valid Last name.
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <p class="title mendatory">Date of Birth</p>
                        <div class="sum-insured-input reg-date-input">
                          <div class="input-group form-group">
                            <div class="input-group addon">
                              <img
                                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                              <p-calendar [touchUI]="true" [readonlyInput]="true"
                                [(ngModel)]="proposal.insuredPersonDob2" dateFormat="dd/mm/yy" [monthNavigator]="true"
                                [yearNavigator]="true" yearRange="1960:{{currentDate.getFullYear()}}" placeholder="Date" name="regDate"
                                [maxDate]="currentDate" (onBlur)="checkValue()" (onSelect)="calculateAge()" keepInvalid required>
                              </p-calendar>
                              <span class="input-group-addon" id="basic-addon-dueDate"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-4"  *ngIf="membersCount == '2'">
                      <div class="col-12 text-center">
                        <button class="btn btn-bordered-blue" [disabled]="!proposalFormTabTwo2.valid" (click)="nextStep('2')">Next</button>
                      </div>
                    </div>
                  </form>
                </div>
                <div id="kid1" class="container tab-pane fade"><br>
                  <form name="form" #kid1FormTab="ngForm">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <select class="form-control" name="insuredMemberRelation3"
                          [(ngModel)]="proposal.insuredMemberRelation3" required>
                          <option value="SON">SON</option>
                          <option value="DAUGHTER">DAUGHTER</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-2 pr-0">
                      <p class="title mendatory">Title</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <select class="form-control" name="kid1Title" [(ngModel)]="proposal.insuredPersonTitle3"
                            id="kid1Title" #kid1Title="ngModel" required>
                            <option value="M">Mr</option>
                            <option value="F">Mrs</option>
                            <option value="F">Ms</option>
                          </select>
                          <div *ngIf="kid1Title.invalid && kid1Title.touched " class="error-message">
                            <div *ngIf="kid1Title.errors.required">
                              Title is required.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-5">
                      <p class="title mendatory">First Name</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" type="text" name="kid1FirstName"
                            [(ngModel)]="proposal.insuredPersonFirstName3" id="kid1FirstName" #kid1FirstName="ngModel"
                            pattern="[a-zA-Z]+" maxlength="200" required>
                            <div *ngIf="kid1FirstName.invalid && kid1FirstName.touched " class="error-message">
                              <div *ngIf="kid1FirstName.errors.required">
                                First Name is required.
                              </div>
                              <div *ngIf="kid1FirstName.errors.pattern">
                                Please enter valid First name.
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-5">
                      <p class="title mendatory">Last Name</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" type="text" name="kid1LastName"
                            [(ngModel)]="proposal.insuredPersonLastName3" id="kid1LastName" #kid1LastName="ngModel"
                            pattern="[a-zA-Z\s]+" maxlength="200" required>
                            <div *ngIf="kid1LastName.invalid && kid1LastName.touched " class="error-message">
                              <div *ngIf="kid1LastName.errors.required">
                                First Name is required.
                              </div>
                              <div *ngIf="kid1LastName.errors.pattern">
                                Please enter valid First name.
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p class="title mendatory">Date of Birth</p>
                      <div class="sum-insured-input reg-date-input">
                        <div class="input-group form-group">
                          <div class="input-group addon">
                            <img
                              src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                            <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.insuredPersonDob3"
                              dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:{{currentDate.getFullYear()}}"
                              placeholder="Date" name="regDate" [maxDate]="currentDate" (onBlur)="checkValue()"
                              (onSelect)="calculateAge()" keepInvalid required></p-calendar>
                            <span class="input-group-addon" id="basic-addon-dueDate"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">

                    <div class="col-12 text-center" *ngIf="membersCount == '3'">
                      <button class="btn btn-bordered-blue" [disabled]="!kid1FormTab.valid" (click)="nextStep('2')">Next</button>
                    </div>
                  </div>
                  </form>
                </div>
                <div id="kid2" class="container tab-pane fade"><br>
                  <form name="form" #kid2FormTab="ngForm">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <select class="form-control" name="insuredMemberRelation4"
                            [(ngModel)]="proposal.insuredMemberRelation4" required>
                            <option value="SON">SON</option>
                            <option value="DAUGHTER">DAUGHTER</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 pr-0">
                        <p class="title mendatory">Title</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <select class="form-control" name="kid2Title" [(ngModel)]="proposal.insuredPersonTitle4"
                              id="kid2Title" #kid2Title="ngModel" required>
                              <option value="M">Mr</option>
                              <option value="F">Mrs</option>
                              <option value="F">Ms</option>
                            </select>
                            <div *ngIf="kid2Title.invalid && kid2Title.touched " class="error-message">
                              <div *ngIf="kid2Title.errors.required">
                                Title is required.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <p class="title mendatory">First Name</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" name="kid2FirstName"
                              [(ngModel)]="proposal.insuredPersonFirstName4" id="kid2FirstName" #kid2FirstName="ngModel"
                              pattern="[a-zA-Z]+" maxlength="200" required>
                              <div *ngIf="kid2FirstName.invalid && kid2FirstName.touched " class="error-message">
                                <div *ngIf="kid2FirstName.errors.required">
                                  First Name is required.
                                </div>
                                <div *ngIf="kid2FirstName.errors.pattern">
                                  Please enter valid First name.
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <p class="title mendatory">Last Name</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" name="kid2LastName"
                              [(ngModel)]="proposal.insuredPersonLastName4" id="kid2LastName" #kid2LastName="ngModel"
                              pattern="[a-zA-Z\s]+" maxlength="200" required>
                              <div *ngIf="kid2LastName.invalid && kid2LastName.touched " class="error-message">
                                <div *ngIf="kid2LastName.errors.required">
                                  First Name is required.
                                </div>
                                <div *ngIf="kid2LastName.errors.pattern">
                                  Please enter valid First name.
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <p class="title mendatory">Date of Birth</p>
                        <div class="sum-insured-input reg-date-input">
                          <div class="input-group form-group">
                            <div class="input-group addon">
                              <img
                                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                              <p-calendar [touchUI]="true" [readonlyInput]="true"
                                [(ngModel)]="proposal.insuredPersonDob4" dateFormat="dd/mm/yy" [monthNavigator]="true"
                                [yearNavigator]="true" yearRange="1960:{{currentDate.getFullYear()}}" placeholder="Date" name="regDate"
                                [maxDate]="currentDate" (onSelect)="calculateAge()" keepInvalid required></p-calendar>
                              <span class="input-group-addon" id="basic-addon-dueDate"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-12 text-center">
                        <button class="btn btn-bordered-blue" [disabled]="!kid2FormTab.valid" (click)="nextStep('2')">Next</button>
                      </div>
                    </div>
                  </form>
                </div>
              </ng-container>
              <!--if no spouse-->
          
            </div>
          </div>
        </div>
        <form name="form" #proposalFormTabThree="ngForm">
          <div [hidden]="nomineeDetails" class="container">
            <div (click)="backtoprevTab('3')" class="left-arw"></div>
            <div class="row">
              <div class="col-2" style="padding-right:0px;">
                <p class="title mendatory">Title</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control" name="nomineeTitle" [(ngModel)]="proposal.nomineeTitle"
                      id="nomineeTitle" #nomineeTitle="ngModel" required>
                      <option value="M">Mr</option>
                      <option value="F">Mrs</option>
                      <option value="F">Ms</option>
                    </select>
                    <div *ngIf="nomineeTitle.invalid && nomineeTitle.touched " class="error-message">
                      <div *ngIf="nomineeTitle.errors.required">
                        Title is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <p class="title mendatory">First Name</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="nomineeFirstName"
                      [(ngModel)]="proposal.nomineeFirstName" id="nomineeFirstName" #nomineeFirstName="ngModel"
                      pattern="[a-zA-Z]+" maxlength="200" required>
                    <div *ngIf="nomineeFirstName.invalid && nomineeFirstName.touched " class="error-message">
                      <div *ngIf="nomineeFirstName.errors.required">
                        First Name is required.
                      </div>
                      <div *ngIf="nomineeFirstName.errors.pattern">
                        Please enter valid First name.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <p class="title mendatory">Last Name</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="nomineeLastName"
                      [(ngModel)]="proposal.nomineeLastName" id="nomineeLastName" #nomineeLastName="ngModel"
                      pattern="[a-zA-Z\s]+" maxlength="200" required>
                    <div *ngIf="nomineeLastName.invalid && nomineeLastName.touched " class="error-message">
                      <div *ngIf="nomineeLastName.errors.required">
                        Last Name is required.
                      </div>
                      <div *ngIf="nomineeLastName.errors.pattern">
                        Please enter valid Last name.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <p class="title mendatory">DOB</p>
                <div class="sum-insured-input reg-date-input date_input">
                  <div class="input-group form-group">
                    <div class="input-group addon">
                      <img
                        src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                      <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.nomineeDob"
                        dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:{{currentDate.getFullYear()}}"
                        placeholder="Date" name="nomineeDob" [maxDate]="currentDate"
                        (onSelect)="calculateAge();getGaurdianMinDobDate(proposal.nomineeDob)" keepInvalid
                        [required]="true"></p-calendar>
                      <span class="input-group-addon" id="basic-addon-dueDate"></span>
                    </div>
                  </div>
                  <div *ngIf="shouldBe18" class="error-message">
                    Date of birth should be greater than 18.
                  </div>
                  <div *ngIf="nomineeDOBrequired" class="error-message">
                    Date of Birth is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Nominee Relationship</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control long-text" id="nomineeRelation" name="nomineeRelation"
                      [(ngModel)]="proposal.nomineeRelationship1" #nomineeRelation="ngModel" required>
                      <option value="Brother">Brother</option>
                      <option value="Brother in Law">Brother in Law</option>
                      <option value="Daughter">Daughter</option>
                      <option value="Father">Father</option>
                      <option value="Grand Father">Grand Father</option>
                      <option value="Grand Mother">Grand Mother</option>
                      <option value="Husband">Husband</option>
                      <option value="Mother">Mother</option>
                      <option value="Mother in Law">Mother in Law</option>
                      <option value="Sister">Sister</option>
                      <option value="Sister in Law">Sister in Law</option>
                      <option value="Son">Son</option>
                      <option value="Wife">Wife</option>
                      <option value="Self">Self</option>
                    </select>
                    <div *ngIf="nomineeRelation.invalid && nomineeRelation.touched " class="error-message">
                      <div *ngIf="nomineeRelation.errors.required">
                        Please select Nominee Relation.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div *ngIf="nomineeGaurdianDetails" class="container"><br>
              <hr>
              <p class="title">If DOB of nominee is less than 18, then guardian details are also needed</p>
              <div class="row">
                <div class="col-2" style="padding-right:0px;">
                  <p class="title mendatory">Title</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <select class="form-control" name="guardianTitle1" [(ngModel)]="proposal.guardianTitle"
                        id="guardianTitle1" #guardianTitle1="ngModel" required>
                        <option value="Mr">Mr</option>
                        <option value="Ms">Ms</option>
                      </select>
                      <div *ngIf="guardianTitle1.invalid && guardianTitle1.touched " class="error-message">
                        <div *ngIf="guardianTitle1.errors.required">
                          Title is required.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <p class="title mendatory">First Name</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="text" name="guardianFirstName1"
                        [(ngModel)]="proposal.guardianFirstName" id="guardianFirstName1" #guardianFirstName1="ngModel"
                        pattern="[a-zA-Z]+" maxlength="200" required>
                      <div *ngIf="guardianFirstName1.invalid && guardianFirstName1.touched " class="error-message">
                        <div *ngIf="guardianFirstName1.errors.required">
                          Guardian's first Name is required.
                        </div>
                        <div *ngIf="guardianFirstName1.errors.pattern">
                          Please enter valid Gaurdian's first name.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <p class="title mendatory">Last Name</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="text" name="guardianLastName1"
                        [(ngModel)]="proposal.guardianLastName" id="guardianLastName1" #guardianLastName1="ngModel"
                        pattern="[a-zA-Z\s]+" maxlength="200" required>
                      <div *ngIf="guardianLastName1.invalid && guardianLastName1.touched " class="error-message">
                        <div *ngIf="guardianLastName1.errors.required">
                          Guardian's last Name is required.
                        </div>
                        <div *ngIf="guardianLastName1.errors.pattern">
                          Please enter valid Last name.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendatory">DOB</p>
                  <div class="sum-insured-input reg-date-input date_input">
                    <div class="input-group form-group">
                      <div class="input-group addon">
                        <img
                          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                        <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.guardianDob"
                          dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                          yearRange="1960:{{maxYearGaurdianDate}}" placeholder="Date" name="guardianDob1"
                          [maxDate]="getGaurdianMinDate" (onSelect)="getGaurdianAge(proposal.guardianDob1);" keepInvalid
                          [required]="true"></p-calendar>
                        <span class="input-group-addon" id="basic-addon-dueDate"></span>
                      </div>
                    </div>
                    <!-- <div *ngIf="shouldBe18" class="error-message">
                    Date of birth should be greater than 18.
                  </div>
                  <div *ngIf="DOBrequired" class="error-message">
                    Date of Birth is required.
                  </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12 text-center">
                <button class="btn btn-bordered-blue" [disabled]="!proposalFormTabThree.valid"
                  (click)="nextStep('3')">Proceed</button>
              </div>
            </div>
          </div>
        </form>
        <form name="form" #proposalFormTabFour="ngForm">
          <div [hidden]="healthDetails" class="container">
            <div (click)="backtoprevTab('4')" class="left-arw"></div>
            <div class="row">
              <div class="col">
                <div class="title">I hereby declare that all proposed members are in good health and entirely free from
                  any mental or physical impairments or deformities, disease/condition. Neither any of the proposed
                  members have been hospitalized for treatment of an illness or injury in past nor consulted any
                  physician or conducted investigation for reasons other than common cough, cold or flu. None of the
                  proposed member are habitual consumer of alcohol, tobacco, gutka or any recreational drugs.</div>
                <input type="radio" [(ngModel)]="proposalForm.question1" name="question1" [value]="false"
                  (change)="onAnsChange(false)"><span class="mr80 ml-2 mr-4">No</span>
                <input type="radio" [(ngModel)]="proposalForm.question1" [checked]="true" name="question1"
                  [value]="true" (change)="onAnsChange(true)"><span class="ml-2">Yes</span>
              </div>
            </div>

            <div class="row mt-4 signatory-section">
              <div class="col-6">
                <p class="title">Date</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="dateSignatory"
                      [(ngModel)]="proposal.authorizedSignatoryDate" id="dateSignatory" #dateSignatory="ngModel"
                      disabled required>
                    <div *ngIf="dateSignatory.invalid && dateSignatory.touched " class="error-message">
                      <div *ngIf="dateSignatory.errors.required">
                        Date is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <p class="title">Name of Policy Holder</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="authorizedSignatory"
                      [(ngModel)]="proposal.authorizedSignatory" id="authorizedSignatory" #authorizedSignatory="ngModel"
                      required>
                    <div *ngIf="authorizedSignatory.invalid && authorizedSignatory.touched " class="error-message">
                      <div *ngIf="authorizedSignatory.errors.required">
                        Policy holder name is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <span id="snackbar"></span>
            <div class="error-message text-center">{{errorMsg}}</div>
            <div class="row mt-5">
              <!-- <div class="col-6 text-right">
                <button class="btn btn-bordered-blue"
                  [disabled]="!proposalFormTabFour.valid || !this.goodHealthDeclaraion"
                  (click)="saveOrSubmitCareProposalPage();">Save</button>
              </div> -->
              <div class="col-12 text-center">
                <button type="button" class="btn btn-bordered-blue"
                  [disabled]="!proposalFormTabFour.valid || !this.goodHealthDeclaraion"
                  (click)="saveOrSubmitCareProposalPage(); openModal(templateTandC);">Proceed</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
  <section class="intimate-successfull" *ngIf="healthThankYou">
    <div class="container">
      <div class="col text-center">
        <h2 class="done-heading">Successfully Done</h2>
        <img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/done-intimate.jpg">
      </div>
      <center class="sub-title mt-2">
        <p>THANK YOU</p>
      </center>
      <!-- <div class="col note text-center">
              <p>We have recieved your intimation requests for policy no. <span class="policyNo">KKL27889</span>.You'll recieve an email from us for further processes, regarding claim form and required document submission.</p>
          </div> -->
      <div class="col footer-strip text-center">
        <p>For any queries, please reach us at:</p>
        <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
          class="img-responsive" width="40%" alt="Securenow">
        <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
      </div>
    </div>
  </section>
  <ng-template #template>

    <div class="modal-body" id="myModal">
      <div class="col">
        <h4 class="modal-title">Contact Info</h4>
      </div>
      <div class="col sum-container">
        <p class="title mt-4">Name</p>
        <div class="sum-insured-input">
          <div class="form-group">
            <input class="form-control" type="text">
          </div>
        </div>
      </div>
      <div class="col sum-container">
        <p class="title mt-4">Mobile No.</p>
        <div class="sum-insured-input">
          <div class="form-group">
            <input class="form-control" type="number" maxlength="10">
          </div>
        </div>
      </div>
      <div class="col sum-container">
        <p class="title mt-4">City</p>
        <div class="sum-insured-input">
          <div class="form-group">
            <input class="form-control" type="text">
          </div>
        </div>
      </div>
      <div class="col sum-container">
        <p class="title mt-4">E-mail Address</p>
        <div class="sum-insured-input">
          <div class="form-group">
            <input class="form-control" type="text">
          </div>
        </div>
      </div>
      <div class="col sum-container">
        <p class="title mt-4">Coupon Code</p>
        <div class="sum-insured-input">
          <div class="form-group">
            <input class="form-control" type="text">
          </div>
        </div>
      </div>
      <div class="col text-center mt-4">
        <button class="btn btn-bordered-blue" aria-label="Close" routerLink="/personal-accident-proposal"
          [disabled]="personalForm.form.invalid" (click)="modalRef.hide()">Next</button>
      </div>
    </div>
  </ng-template>
  <ng-template #templateTandC>
    <form name="form" (ngSubmit)="f.form.valid" #f="ngForm">
      <div class="modal-body">
        <div class="col">
          <h4 class="modal-title">Terms & Conditions</h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col mt-4">
          <div class="checkbox" *ngIf="!environment.production">
            <label><input type="checkbox" name="termCheck" id="termCheck" name="termCheck" [(ngModel)]="f.termCheck"
                #termCheck="ngModel" required> I hereby agree to the <a
                href="https://pamstaging2.securenow.in/terms-conditions" target="_blank">terms &amp;
                conditions</a> of the purchase of this policy.</label>
          </div>
          <div class="checkbox" *ngIf="environment.production">
            <label><input type="checkbox" name="termCheck" id="termCheck" name="termCheck" [(ngModel)]="f.termCheck"
                #termCheck="ngModel" required> I hereby agree to the <a
                href="https://securenow.in/terms-conditions" target="_blank">terms &amp;
                conditions</a> of the purchase of this policy.</label>
          </div>
          <div class="checkbox">
            <label><input type="checkbox" name="termCheck" id="termCheck2" name="termCheck2" [(ngModel)]="f.termCheck2"
                #termCheck2="ngModel"> I here by agree to receive service SMS and email alerts</label>
          </div>
        </div>

        <div class="col text-center mt-4">
          <button class="btn btn-bordered-blue" aria-label="Close"
            (click)="modalRef.hide();careHealthProccedtoPayment();" [disabled]="f.form.invalid">Pay</button>
        </div>

        <!-- <div class="col text-center mt-4">
          <button class="btn btn-bordered-blue" aria-label="Close"
            (click)="modalRef.hide();showThankYouModal(templateThankYou);" [disabled]="f.form.invalid">Pay</button>
        </div> -->
      </div>
    </form>
  </ng-template>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>
<div id="spinner" [hidden]="!loading">
  <div class="spinnerfull">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</div>


<ng-template #templateThankYou>
  <!-- <div class="modal-header">
      
    </div> -->
  <form name="form" (ngSubmit)="f.form.valid" #f="ngForm">
    <div class="modal-body" id="contactInfoModal">
      <div class="col">
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="col text-center mt-4">
        <h4 class="modal-title">Thank You</h4>
        <p>We will call you back within 24 hours.</p>
      </div>
    </div>
  </form>

</ng-template>